var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "lastAccessModal",
      attrs: {
        id: "last-access-modal",
        title: _vm.$t("last_access.title"),
        size: "md",
        centered: ""
      },
      on: { hide: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex justify-content-end" },
                [
                  _c(
                    "b-button",
                    { attrs: { variant: "primary" }, on: { click: _vm.close } },
                    [_vm._v(" " + _vm._s(_vm.$t("action.close")) + " ")]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _vm.lastAccess
        ? _c("div", { staticClass: "access-details" }, [
            _c("div", { staticClass: "detail-row" }, [
              _c(
                "div",
                { staticClass: "detail-label" },
                [
                  _c("feather-icon", {
                    staticClass: "detail-icon text-primary",
                    attrs: { icon: "ClockIcon", size: "18" }
                  }),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("last_access.date_time")) + ":")
                  ])
                ],
                1
              ),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.formatDateTime(_vm.lastAccess.login_at)))
              ])
            ]),
            _c("div", { staticClass: "detail-row" }, [
              _c(
                "div",
                { staticClass: "detail-label" },
                [
                  _c("feather-icon", {
                    staticClass: "detail-icon text-primary",
                    attrs: { icon: "GlobeIcon", size: "18" }
                  }),
                  _c("strong", [_vm._v(_vm._s(_vm.$t("last_access.ip")) + ":")])
                ],
                1
              ),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.lastAccess.ip_address || "--"))
              ])
            ]),
            _c("div", { staticClass: "detail-row" }, [
              _c(
                "div",
                { staticClass: "detail-label" },
                [
                  _c("feather-icon", {
                    staticClass: "detail-icon text-primary",
                    attrs: { icon: "MonitorIcon", size: "18" }
                  }),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("last_access.browser")) + ":")
                  ])
                ],
                1
              ),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.lastAccess.browser || "--"))
              ])
            ]),
            _c("div", { staticClass: "detail-row" }, [
              _c(
                "div",
                { staticClass: "detail-label" },
                [
                  _c("feather-icon", {
                    staticClass: "detail-icon text-primary",
                    attrs: { icon: "LayersIcon", size: "18" }
                  }),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("last_access.platform")) + ":")
                  ])
                ],
                1
              ),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.lastAccess.platform || "--"))
              ])
            ]),
            _c("div", { staticClass: "detail-row" }, [
              _c(
                "div",
                { staticClass: "detail-label" },
                [
                  _c("feather-icon", {
                    staticClass: "detail-icon text-primary",
                    attrs: { icon: "SmartphoneIcon", size: "18" }
                  }),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("last_access.device")) + ":")
                  ])
                ],
                1
              ),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.formatDeviceType(_vm.lastAccess.device_type)))
              ])
            ]),
            _vm.lastAccess.user_agent
              ? _c("div", { staticClass: "detail-row" }, [
                  _c(
                    "div",
                    { staticClass: "detail-label" },
                    [
                      _c("feather-icon", {
                        staticClass: "detail-icon text-primary",
                        attrs: { icon: "InfoIcon", size: "18" }
                      }),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("last_access.user_agent")) + ":")
                      ])
                    ],
                    1
                  ),
                  _c("span", { staticClass: "detail-value user-agent" }, [
                    _vm._v(_vm._s(_vm.lastAccess.user_agent))
                  ])
                ])
              : _vm._e()
          ])
        : _c("div", { staticClass: "no-access" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("last_access.no_access_found")))])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }